import React, {FunctionComponent, useCallback, useState} from "react";
import {useIsMounted} from "../../../index";
import {Utils} from "../../../../core";
import {Box, DialogContent, IconButton, Theme, Tooltip, Typography} from "@mui/material";
import {ContentCopy, DoneAllRounded} from "@mui/icons-material";
import {SubmitTicketDialogSubmissionResult} from "../index";
import {ReactComponent as TicketSubmissionSVG} from '../../../../assets/svgs/ticket-submission-success.svg';

export interface SubmittedTicketSectionProps extends SubmitTicketDialogSubmissionResult {
}

const SubmittedTicketSection: FunctionComponent<SubmittedTicketSectionProps> = (props) => {
    const [copied, setCopied] = useState(false);
    const isMounted = useIsMounted();

    /**
     * Copies the ticket's link to the clipboard.
     */
    const copyToClipboard = useCallback(async () => {
        const result = await Utils.copyToClipboard(props.link);
        if (result) {
            setCopied(true);
            setTimeout(() => {
                if (!isMounted())
                    return;
                setCopied(false);
            }, 3000)
        }
    }, [props.link, isMounted])

    /**
     * Creates the styles for the container boxes.
     * @param {Theme} theme                      The theme to use
     * @returns {ReturnType<ThemeMixin<Theme>>}  The styles for the container boxes
     */
    const boxMixin = useCallback<ThemeMixin<Theme>>((theme) => ({
        backgroundColor: theme.palette.background.tertiary,
        borderRadius: theme.vars?.shape.borderRadius,
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }), []);

    return (
        <>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, marginBlock: 4}}>
                    <TicketSubmissionSVG style={{width: '80%', margin: 'auto', maxHeight: '40vh'}}/>
                    <Typography variant={'body2'}>
                        Your ticket has been submitted successfully. You can view it by clicking on the following code:
                    </Typography>
                    <Box sx={boxMixin}>
                        <Typography
                            variant={'body2'}
                            color={'primary'}
                            component={'a'}
                            href={props.link}
                            target={'_blank'}
                        >
                            {props.code ?? 'CODE UNAVAILABLE'}
                        </Typography>
                        <Tooltip
                            classes={{popper: 'submit-ticket-dialog-success-tooltip-root'}}
                            title={copied ? "Link copied" : "Copy ticket's link"}
                            placement={'left'}
                            arrow
                            enterDelay={100}
                            enterTouchDelay={100}
                        >
                            <IconButton
                                color={copied ? 'paper.success' : 'paper.primary'}
                                size={'medium'}
                                onClick={copyToClipboard}
                            >
                                {
                                    copied
                                        ? <DoneAllRounded/>
                                        : <ContentCopy/>
                                }
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </DialogContent>
        </>
    );
}

export default SubmittedTicketSection;
